import { Row, Col, Divider, Table } from 'antd';
import { useEffect, createRef, useState } from 'react';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import StoricoService from 'services/storico';
import Loading from 'components/loading';
import _ from 'lodash';
import pdfIcon from 'assets/img/formats/pdf.png';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import Utils from '../../utils';
import RicercaCodiceSvc from 'services/ricercaCodice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import '../../css/_ricercaCodice.scss';

function StoriaUA({ isMobile, resetCounter, defaultSkip, queryString }) {
  const typeaheadRef = createRef();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(false);
  const [riepilogoColumns, setRiepilogoColumns] = useState([]);
  const [riepilogoRows, setRiepilogoRows] = useState([]);
  const [dettaglioColumns, setDettaglioColumns] = useState([]);
  const [dettaglioRows, setDettaglioRows] = useState([]);
  const [datiVariazioneColumns, setDatiVariazioneColumns] = useState([]);
  const [datiVariazioneRows, setDatiVariazioneRows] = useState([]);
  const [valueList, setValueList] = useState([]);
  const [filteredValueList, setFilteredValueList] = useState([]);
  const [checked, setChecked] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [title, setTitle] = useState();
  const [isBug, setIsBug] = useState(false);
  const [selectedValue, setSelectedValue] = useState();
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [descrizioneEvento, setDescrizioneEvento] = useState();
  const [statusEventoSR, setStatusEventoSR] = useState();
  const [oldCounter, setOldCounter] = useState(1);

  const uaType = {
    regione: 'regione',
    provincia: 'provincia',
    comune: 'comune'
  };

  useEffect(() => {
    if (resetCounter !== oldCounter) {
      setChecked(null);
      setSelectedRow('');
      setRiepilogoRows([]);
      setDettaglioRows([]);
      setDatiVariazioneRows([]);
      setDettaglioColumns([]);
      setRiepilogoColumns([]);
      setDatiVariazioneColumns([]);
      setSelected(false);
      setDescrizioneEvento();
      setStatusEventoSR();
      setTitle();
      typeaheadRef.current.clear();

      setOldCounter(resetCounter);
    }
  }, [resetCounter]);

  useEffect(() => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');
    document.title = 'Storia unità territoriali - SITUAS';

    let mounted = false;
    const fetchList = async () => {
      try {
        const { data } = await RicercaCodiceSvc.getList();
        if (!mounted) {
          setList(data.items);
          setLoading(false);
        }
      } catch {
        setLoading(false);
      }
    };
    fetchList();
    return () => {
      mounted = true;
    };
  }, []);
  useEffect(() => {}, [isChecked, selected]);

  useEffect(() => {
    let mounted = false;
    if (!mounted) {
      setSelectedValue();
    }
    const fetchValueList = async () => {
      if (checked) {
        setLoading(true);
        let data;
        try {
          switch (checked.return_code) {
            case 3:
              ({ data } = await StoricoService.regione('', null));
              if (!mounted) {
                setValueList(
                  data?.items.map((obj, i) => ({
                    label: `${obj['cod_regione']} - ${obj['denominazione regione']} - ${obj['descrizione tipo regione']}`,
                    value: i,
                    codice: obj['cod_regione'],
                    denominazione: obj['denominazione regione'],
                    tipo: obj['tipo regione'],
                    key: i
                  }))
                );
                setFilteredValueList(
                  data.items.map((obj, i) => ({
                    label:`${obj['cod_regione']} - ${obj['denominazione regione']} - ${obj['descrizione tipo regione']}`,
                    value: i,
                    codice: obj['cod_regione'],
                    denominazione: obj['denominazione regione'],
                    tipo: obj['tipo regione'],
                    key: i
                  }))
                );
                setLoading(false);
              }
              break;
            case 2:
              ({ data } = await StoricoService.provinceUts('', null));
              if (!mounted) {
                setValueList(
                  data?.items.map((obj, i) => ({
                    label: `${obj['cod_uts']} - ${obj['denominazione_uts']} - ${obj['descrizione tipo uts']}`,
                    value: i,
                    denominazione: obj['denominazione_uts'],
                    codice: obj['cod_uts'],
                    tipo: obj['tipo uts'],
                    key: i
                  }))
                );
                setFilteredValueList(
                  data.items.map((obj, i) => ({
                    label: `${obj['cod_uts']} - ${obj['denominazione_uts']} - ${obj['descrizione tipo uts']}`,
                    value: i,
                    denominazione: obj['denominazione_uts'],
                    codice: obj['cod_uts'],
                    tipo: obj['tipo uts'],
                    key: i
                  }))
                );
                setLoading(false);
              }
              break;
            case 1:
              ({ data } = await StoricoService.comune('', null));
              if (!mounted) {
                setValueList(
                  data?.items.map(({ comune: com, pro_com_t }, i) => ({
                    label: `${pro_com_t} - ${com}`,
                    value: i,
                    denominazione: com,
                    codice: pro_com_t,
                    key: i
                  }))
                );
                setFilteredValueList(
                  data.items.map(({ comune: com, pro_com_t }, i) => ({
                    label: `${pro_com_t} - ${com}`,
                    value: i,
                    denominazione: com,
                    codice: pro_com_t,
                    key: i
                  }))
                );
                setLoading(false);
              }
              break;
            default:
              break;
          }
        } catch {
          setLoading(false);
        }
      }
    };
    fetchValueList();
    return () => {
      mounted = true;
    };
  }, [checked]);

  const search = (inputValue) => {
    setSelected(false);
    setSelectedValue({ label: inputValue });
    if (inputValue?.length > 0) {
      let filtered = valueList.filter((value) =>
        value.label.split('-')[1].toLowerCase().trim().startsWith(inputValue.toLowerCase())
      );

      if (!filtered.length) {
        filtered = valueList.filter((value) =>
          value.label.split('-')[0].toLowerCase().trim().startsWith(inputValue.toLowerCase())
        );
      }

      if (!filtered.length) {
        filtered = valueList.filter((value) =>
          value.label.toLowerCase().trim().startsWith(inputValue.toLowerCase())
        );
      }
      setFilteredValueList(filtered);
    } else {
      setFilteredValueList(valueList);
    }
  };

  const executeSearch = async () => {
    setDettaglioRows([]);
    setDettaglioColumns([]);
    setDatiVariazioneRows([]);
    setDatiVariazioneColumns([]);
    setSelectedRow();
    setDescrizioneEvento();
    setStatusEventoSR();
    if (selected) {
      switch (checked.return_code) {
        case 1:
          setLoading(true);

          const codiceComune = selectedValue.codice;
          let denominazioneComune = selectedValue.denominazione;

          setRiepilogoColumns([]);
          setRiepilogoRows([]);
          try {
            const { data } = await StoricoService.comuneRiepilogo(
              codiceComune,
              denominazioneComune
            );

            setTitle(denominazioneComune + ' - ' + codiceComune);
            const objectOrder = {
              variazione: null
            };
            const column = Object.assign(objectOrder, data.items[0]);
            const formattedColumns = Object.keys(
              _.omit(column, [
                'identificativo provvedimento',
                'codice comune corrente',
                'denominazione corrente',
                'descrizione evento',
                'id_comune_origine',
                'orderr',
                'data_inizio_amministrativa',
                'tipo variazione'
              ])
            ).map((key) => ({
              title: /*_.capitalize*/ Utils.customCapitalize(key),
              dataIndex: key,
              key: key,
              onCell: () => ({
                style: { textAlign: 'left' }
              })
            }));
            const formattedRows = data.items.map((row, i) => {
              let rowObject = {
                key: row['id_comune_origine'] + '§' + row['identificativo provvedimento'] + '§' + i,
                id: i
              };
              Object.keys(
                _.omit(row, [
                  'identificativo provvedimento',
                  'codice comune corrente',
                  'denominazione corrente',
                  'id_comune_origine'
                ])
              ).forEach((value) => {
                rowObject = { ...rowObject, [value]: row[value], uaType: uaType.comune };
              });
              return rowObject;
            });
            setRiepilogoColumns(formattedColumns);
            setRiepilogoRows(formattedRows);
            setLoading(false);
          } catch {
            setLoading(false);
          }
          break;

        case 2:
          setLoading(true);
          const codiceProvincia = selectedValue.codice;
          let denominazioneProvincia = selectedValue.denominazione;
          const tipoProvincia = selectedValue.tipo;

          setRiepilogoColumns([]);
          setRiepilogoRows([]);
          try {
            const { data } = await StoricoService.provinceUtsRiepilogo(
              codiceProvincia,
              denominazioneProvincia,
              tipoProvincia
            );
            setTitle(denominazioneProvincia + ' - ' + codiceProvincia);
            const objectOrder = {
              variazione: null
            };
            const column = Object.assign(objectOrder, data.items[0]);
            const formattedColumns = Object.keys(
              _.omit(column, [
                'identificativo provvedimento',
                'descrizione evento',
                'codice uts corrente',
                'denominazione corrente',
                'id_uts',
                'tipo uts',
                'tipo variazione',
                'id_uts_origine'
              ])
            ).map((key) => ({
              title: /*_.capitalize*/ Utils.customCapitalize(key),
              onCell: () => ({
                style: { textAlign: 'left' }
              }),
              dataIndex: key,
              key: key
            }));
            const formattedRows = data.items.map((row, i) => {
              let rowObject = {
                key:
                  row['identificativo provvedimento'] +
                  '§' +
                  row['tipo uts'] +
                  '§' +
                  row['id_uts'] +
                  '§' +
                  row['tipo variazione'],
                id: i
              };
              Object.keys(_.omit(row, 'identificativo provvedimento')).forEach((value) => {
                rowObject = { ...rowObject, [value]: row[value], uaType: uaType.provincia };
              });
              return rowObject;
            });
            setRiepilogoColumns(formattedColumns);
            setRiepilogoRows(formattedRows);
            setLoading(false);
          } catch {
            setLoading(false);
          }
          break;

        case 3:
          setLoading(true);

          const codiceReg = selectedValue.codice;
          let denominazioneReg = selectedValue.denominazione;
          const tipoRegione = selectedValue.tipo;

          const lastIndex = denominazioneReg.lastIndexOf('-');
          if (denominazioneReg.split('-').length > 1) {
            if (
              lastIndex !== -1 &&
              !denominazioneReg[lastIndex - 1].toLowerCase().match(/[a-z]/i)
            ) {
              denominazioneReg = (
                denominazioneReg.substring(0, lastIndex) +
                '' +
                denominazioneReg.substring(lastIndex + 1)
              ).trim();
            }
          } else {
            if (!denominazioneReg[lastIndex - 1]?.toLowerCase()?.match(/[a-z]/i)) {
              denominazioneReg = denominazioneReg.replace('-', '').trim();
            }
          }

          setRiepilogoColumns([]);
          setRiepilogoRows([]);
          try {
            const { data } = await StoricoService.regioneRiepilogo(
              codiceReg,
              denominazioneReg,
              tipoRegione
            );
            setTitle(denominazioneReg + ' - ' + codiceReg);
            const objectOrder = {
              variazione: null
            };
            const columns = Object.assign(objectOrder, data.items[0]);
            const formattedColumns = Object.keys(
              _.omit(columns, [
                'identificativo provvedimento',
                'descrizione evento',
                'codice uts corrente',
                'denominazione corrente',
                'id_regione',
                'tipo reg',
                'tipo variazione',
                'id_regione_origine'
              ])
            ).map((key) => ({
              title: /*_.capitalize*/ Utils.customCapitalize(key),
              dataIndex: key,
              key: key,
              onCell: () => ({
                style: { textAlign: 'left' }
              })
            }));
            const formattedRows = data.items.map((row, i) => {
              let rowObject = {
                key:
                  row['identificativo provvedimento'] +
                  '*' +
                  row['data decorrenza'] +
                  row['tipo variazione'],
                id: i
              };
              Object.keys(_.omit(row, 'identificativo provvedimento')).forEach((value) => {
                rowObject = { ...rowObject, [value]: row[value], uaType: uaType.regione };
              });
              return rowObject;
            });
            setRiepilogoColumns(formattedColumns);
            setRiepilogoRows(formattedRows);
            setLoading(false);
          } catch {
            setLoading(false);
          }
          break;
        default:
          break;
      }
    }
  };

  const handleRowClick = async (e) => {
    setLoading(true);
    setDescrizioneEvento(e['descrizione evento']);
    setStatusEventoSR();
    if (e.uaType === uaType.comune) {
      try {
        const { data } = await StoricoService.dettVariazioni(
          e['key'].split('§')[1],
          e['tipo variazione'],
          e['key'].split('§')[0]
        );

        const objectOrder = {
          variazione: null
        };
        const columns = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(columns, ['identificativo_provvedimento', 'tipo variazione'])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/ Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.values(_.omit(row, 'identificativo_provvedimento')).forEach((value, i) => {
            const isPdf =
              Object.keys(_.omit(data.items[0], 'identificativo_provvedimento'))[i] === 'url_pdf';
            rowObject = {
              ...rowObject,
              [Object.keys(_.omit(data.items[0], 'identificativo_provvedimento'))[i]]: isPdf ? (
                row['url_pdf'] ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                    <img
                      src={pdfIcon}
                      style={{ height: 'auto', width: '30px' }}
                      alt="pdf download"
                    />
                  </a>
                ) : (
                  '-'
                )
              ) : value?.length > 0 ? (
                value
              ) : (
                '-'
              )
            };
          });
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioni(
          e['key'].split('§')[1],
          e['tipo variazione'],
          e['key'].split('§')[0]
        );
        const columns = data.items[0];
        const formattedColumns = Object.keys(
          _.omit(columns, ['variazione', 'tipo variazione'])
        ).map((key) => ({
          title: /*_.capitalize*/ Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, [''])).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else if (e.uaType === uaType.provincia) {
      try {
        const { data } = await StoricoService.dettVariazioniUts(
          e['tipo variazione'],
          e['key'].split('§')[0],
          //e['key'].split('§')[2],
          e['id_uts_origine'],
          e['key'].split('§')[1]
        );
        const objectOrder = {
          variazione: null
        };
        const column = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(column, [
            'identificativo_provvedimento',
            'dt_prv_var',
            'tipo variazione',
            'id_uts_origine'
          ])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/ Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, ['identificativo_provvedimento', 'dt_prv_var'])).forEach(
            (value) => {
              const isPdf = value === 'url_pdf';

              rowObject = {
                ...rowObject,
                [value]: isPdf ? (
                  row['url_pdf'] ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                      <img
                        src={pdfIcon}
                        style={{ height: 'auto', width: '30px' }}
                        alt="pdf download"
                      />
                    </a>
                  ) : (
                    '-'
                  )
                ) : row[value]?.length > 0 ? (
                  row[value]
                ) : (
                  '-'
                )
              };
            }
          );
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioniUts(
          e['tipo variazione'],
          e['key'].split('§')[0],
          //e['key'].split('§')[2],
          e['id_uts_origine'],
          e['key'].split('§')[1]
        );
        const column = data.items[0];
        const formattedColumns = Object.keys(
          _.omit(column, ['tipo variazione', 'descrizione variazione'])
        ).map((key) => ({
          title: /*_.capitalize*/ Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(row).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else if (e.uaType === uaType.regione) {
      // TODO!
      try {
        const { data } = await StoricoService.dettVariazioniRegione(
          e['tipo variazione'],
          e['tipo reg'],
          e['key'].split('*')[0],
          e['id_regione_origine']
        );
        const objectOrder = {
          variazione: null
        };
        const columns = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(columns, [
            'identificativo_provvedimento',
            'dt_prv_var',
            'tipo variazione',
            'id_regione_origine'
          ])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/ Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, ['identificativo_provvedimento', 'dt_prv_var'])).forEach(
            (value) => {
              const isPdf = value === 'url_pdf';
              rowObject = {
                ...rowObject,
                [value]: isPdf ? (
                  row['url_pdf'] ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                      <img
                        src={pdfIcon}
                        style={{ height: 'auto', width: '30px' }}
                        alt="pdf download"
                      />
                    </a>
                  ) : (
                    '-'
                  )
                ) : row[value]?.length > 0 ? (
                  row[value]
                ) : (
                  '-'
                )
              };
            }
          );
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioniReg(
          e['tipo variazione'],
          e['tipo reg'],
          e['key'].split('*')[0],
          e['id_regione_origine']
        );

        const objectOrder = {
          'Codice Ripartizione': null,
          'Codice Compartimento/Regione': null,
          Denominazione: null
        };
        const columns = Object.assign(objectOrder, data.items[0]);

        const formattedColumns = Object.keys(
          _.omit(columns, ['identificativo_provvedimento', 'dt_prv_var', 'descrizione variazione'])
        ).map((key) => ({
          title:
            key === 'CodCompRegAss'
              ? 'Codice Compartimento/Regione associato'
              : /*_.capitalize*/ Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(row).forEach((value) => {
            rowObject = {
              ...rowObject,
              [value]: row[value]
            };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else {
      setSelectedRow('');
      setRiepilogoRows([]);
      setDettaglioRows([]);
      setDatiVariazioneRows([]);
      setDettaglioColumns([]);
      setRiepilogoColumns([]);
      setDatiVariazioneColumns([]);
      setSelected(false);
      setTitle();
      setLoading(false);
    }
    setStatusEventoSR('Descrizione Evento: ' + e['descrizione evento']);
  };

  useEffect(() => {
    // FIX ARIA-EXPANDED NON PRESENTE INIZIALMENTE
    var autocompletes = document.getElementsByClassName('ant-select-selection-search-input');

    for (var i = 0; i < autocompletes.length; i++) {
      var element = autocompletes[i];
      element.setAttribute('aria-expanded', 'false');
      element.setAttribute('aria-activedescendant', '');
    }
  });

  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <Row className="box-3 storiaua">
        {loading && <Loading fullPage={true} />}
        <Col sm={24} lg={8} xl={6}>
          <form className="mt-5 pt-2 d-flex flex-column justify-content-start storia-ua-criteri-container" role="search" name="Criteri di ricerca">
            <div>
              <fieldset role="radiogroup" aria-describedby="criteri-desc">
                <legend className="text-secondary">Criteri di ricerca</legend>
                <p className="sr-only" id="criteri-desc">
                  I risultati vengono mostrati simultaneamente all'impostazione dei filtri
                </p>

                {list?.map(({ return_code, label_tipologia }, idx) => {
                  return (
                    <Form.Check
                      id={'criteri-' + idx}
                      type="radio"
                      name="criteri"
                      tabIndex={0}
                      aria-label={label_tipologia}
                      key={`${label_tipologia}-${idx}`}
                      className="ml-2"
                      label={label_tipologia}
                      checked={checked?.label_tipologia === label_tipologia}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setChecked({ return_code, label_tipologia });
                          setSelectedValue();
                          setSelected(false);
                          setIsChecked(true);
                          typeaheadRef.current?.clear();
                        } else {
                          setChecked();
                          setIsChecked(false);
                          setSelectedValue();
                          setSelected(false);
                        }
                      }}></Form.Check>
                  );
                })}
              </fieldset>
            </div>
            <div>
              <p id="cerca-desc" className="sr-only">
                {(!checked || !selected) ? 'Popolare i filtri di ricerca per abilitare il pulsante.' : ''}
              </p>
              <fieldset>
              <p id='storiaua-ricerca-desc' className='sr-only'>, selezionare un'unità territoriale per abilitare la casella di ricerca.</p>
                <Typeahead
                  ref={typeaheadRef}
                  id="storiaua-ricerca-typeahead"
                  className="storia-ua-denominazione mt-2 mb-3"
                  tabIndex={0}
                  open={(checked && valueList.length > 0) ? undefined : false}
                  inputProps={{
                      id:"storiaua-ricerca",
                      "aria-disabled":(!checked || !valueList.length > 0),
                      "aria-describedby":(checked && valueList.length > 0) ? '' : 'storiaua-ricerca-desc',
                      className:(checked && valueList.length > 0) ? '' : 'criteri-ricerca-input-disabled',
                      readOnly:(!checked || !valueList.length > 0)
                    }}
                  placeholder={(checked && valueList.length > 0) ? `Codice/Denominazione ${checked?.label_tipologia}` : ''}
                  onKeyDown={(event) => {
                    if (event.key === "Enter")
                      event.preventDefault();
                  }}
                  onChange={(selection) => {
                    if (selection && selection.length === 1) {
                      const option = new Object(selection[0]);
                      setSelectedValue(option);
                      setSelected(true);
                    }
                  }}
                  onBlur={(event) => {
                    if(event?.target.value === ''){
                      setSelected(false);
                    }
                  }}
                  value={selectedValue?.label}
                  options={filteredValueList}
                  renderMenu={(results) => (
                    <Menu id='storiaua-menu-options' aria-label='Opzioni menù' className='storiaua-typeahead-menu-options' emptyLabel='Nessun dato'>
                      {results.map((result, index) => (
                        <MenuItem option={result} position={index} key={`storiaua-option-${index}`} aria-live='polite' aria-atomic='true'>
                          {result.paginationOption ?
                            <><FontAwesomeIcon className="typeahead-pagination-icon mr-2" aria-hidden="true" icon={faChevronCircleDown} />Carica più risultati</>
                            :
                            result.label
                          }
                        </MenuItem>
                      ))}
                    </Menu>
                  )}
                  paginationText="Carica più risultati"

                />
              </fieldset>
            </div>
            <button
              tabIndex={0}
              type="button"
              aria-describedby="cerca-desc"
              aria-disabled={!checked || !selected}
              className={`storia-ua-button mt-2 ${!checked || !selected ? 'btn-search-disabled' : ''}`}
              onClick={() => {
                executeSearch();
              }}>
              Cerca
            </button>
            <button
              tabIndex={0}
              type="button"
              className="storia-ua-button mb-5"
              onClick={() => {
                setChecked(null);
                setSelectedRow('');
                setRiepilogoRows([]);
                setDettaglioRows([]);
                setDatiVariazioneRows([]);
                setDettaglioColumns([]);
                setRiepilogoColumns([]);
                setDatiVariazioneColumns([]);
                setSelected(false);
                setDescrizioneEvento();
                setStatusEventoSR();
                setTitle();
                typeaheadRef.current.clear();
              }}>
              Annulla
            </button>

            {descrizioneEvento && (
              <div>
                <div className="card p-2 descrizione">
                  <span className="storia-ua-event-title">Descrizione evento:</span>
                  <div> {descrizioneEvento} </div>
                </div>
                <div
                  className={` ${
                    descrizioneEvento.length > 90 ? 'read-more-enabled' : 'read-more-disabled'
                  }`}>
                  <button
                    className="read-more storia-ua-button mt-4 mb-5"
                    type="button"
                    onClick={() => {
                      document.querySelector('.descrizione').classList.toggle('expanded');
                      document.querySelector('.read-more').textContent = document
                        .querySelector('.descrizione')
                        .classList.contains('expanded')
                        ? 'Leggi di meno'
                        : 'Leggi di più';
                    }}>
                    Leggi di più
                  </button>
                </div>
              </div>
            )}
          </form>

          <span className="sr-only" role="status" aria-live="polite">{title ? `Ricerca per ${checked?.label_tipologia} ${title}` : ''}</span>
          <span className="sr-only" role="status" aria-live="polite"> {statusEventoSR} </span>

          {isMobile && riepilogoRows.length > 0 && (
            <>
              {title && <div className="storia-ua-title">{title}</div>}
              <div className="storia-ua-header">Riepilogo variazioni</div>
              <Table
                scroll={{ x: 1000 }}
                bordered
                dataSource={riepilogoRows}
                columns={riepilogoColumns}
                pagination={false}
                rowClassName="storia-ua-rows"
                rowKey={(record) => record.id}
                onRow={(record) => {
                  return {
                    tabIndex: 0,
                    "aria-label": `${record.id}`,
                    onClick: () => handleRowClick(record),
                    onKeyDown: (event) => {
                      if (event.key === 'Enter') {
                        handleRowClick(record);
                      }
                    }
                  };
                }}
              />
              {dettaglioRows.length > 0 && (
                <>
                  <div className="storia-ua-header mt-5">Dettaglio provvedimento</div>
                  <Table
                    scroll={{ x: 1000 }}
                    bordered
                    dataSource={dettaglioRows}
                    columns={dettaglioColumns}
                    pagination={false}
                  />
                </>
              )}
              {datiVariazioneRows.length > 0 && (
                <>
                  <div className="storia-ua-header mt-5">Dettaglio variazione</div>
                  <Table
                    scroll={{ x: 1000 }}
                    bordered
                    dataSource={datiVariazioneRows}
                    columns={datiVariazioneColumns}
                    pagination={false}
                  />
                </>
              )}
            </>
          )}
        </Col>
        <Col
          xs={{ span: 23, order: 1 }}
          lg={{ span: 14, order: 2 }}
          xl={{ span: 16, order: 2 }}
          offset={1}>
          <div role="status" aria-live="polite">
            <h2 className="title-main">Storia unità territoriali</h2>
            <Divider className="blue-divider" />
            {!riepilogoRows.length > 0 && (
              <div>
                Dopo aver ricercato la denominazione/codice dell'unità di interesse il sistema
                restituisce il riepilogo delle variazioni. <br />
                Selezionata una variazione sono mostrati estremi e dettagli del provvedimento e unità
                coinvolte.
              </div>
            )}
            {riepilogoRows.length > 0 && (
              <>
                {title && <div className="storia-ua-title">{title}</div>}
                <div className="storia-ua-header">Riepilogo variazioni</div>
                <Table
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={riepilogoRows}
                  columns={riepilogoColumns}
                  pagination={false}
                  rowKey={(record) => record.id}
                  rowClassName={(_, index) => {
                    return index === selectedRow
                      ? 'storia-ua-rows selected storia-ua-rows'
                      : 'storia-ua-rows storia-ua-rows';
                  }}
                  onRow={(record, index) => {
                    return {
                      tabIndex: 0,
                      "aria-label": `Approfondisci ${record.variazione} in data ${record['data evento']}. `,
                      onClick: () => {
                        handleRowClick(record);
                        setSelectedRow(index);
                      },
                      onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                          handleRowClick(record);
                        }
                      }
                    };
                  }}
                />
              </>
            )}
          </div>
          <div role="status" aria-live="polite">
            {riepilogoRows.length > 0 && dettaglioRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio provvedimento</div>
                <Table
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={dettaglioRows}
                  columns={dettaglioColumns}
                  pagination={false}
                />
              </>
            )}
          </div>
          <div role="status" aria-live="polite">
            {riepilogoRows.length > 0 && datiVariazioneRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio variazione</div>
                <Table
                  className="mb-5"
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={datiVariazioneRows}
                  columns={datiVariazioneColumns}
                  pagination={false}
                />
              </>
            )}
          </div>
        </Col>
      </Row>
    </main>
  );
}
export default StoriaUA;
